import groups from './groups'
export default {
    install(Vue,options){
        Vue.prototype.$api = this
    },
    ...groups
}
